import { useState } from 'react';
import type { Anomaly, AnomalySeverity } from '@/api/types';
import { useAckAnomaly } from '@/api/hooks/anomalies';
import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/Dialog';
import { Field, Input } from '@/components/ui/Field';
import { toast } from '@/stores/toast';

/** Общото за „Аномалии", страницата на буса и картите в „Начало". */
export const SEVERITY: Record<AnomalySeverity, { dot: string; label: string }> = {
  high: { dot: 'bg-danger', label: 'важно' },
  medium: { dot: 'bg-warn', label: 'за проверка' },
  low: { dot: 'bg-line-strong', label: 'за сведение' },
};

/** Сървърът дава адрес с параметри („/service?tab=signals"); рутерът иска път и параметри поотделно. */
export function anomalyLink(link: string): { to: never; search?: never } {
  const [path, query] = link.split('?');
  return query
    ? { to: path as never, search: Object.fromEntries(new URLSearchParams(query)) as never }
    : { to: path as never };
}

/** „Прегледано" — по желание с бележка, която остава видима до реда. */
export function AckDialog({ anomaly, onClose }: { anomaly: Anomaly | null; onClose: () => void }) {
  const ack = useAckAnomaly();
  const [note, setNote] = useState('');
  if (!anomaly) return null;
  const close = () => {
    setNote('');
    onClose();
  };
  return (
    <Dialog
      open
      onClose={close}
      title="Прегледано"
      description={anomaly.title}
      footer={
        <>
          <Button variant="ghost" onClick={close}>
            Отказ
          </Button>
          <Button
            variant="primary"
            loading={ack.isPending}
            onClick={() =>
              ack.mutate(
                { key: anomaly.key, ...(note.trim() ? { note: note.trim() } : {}) },
                {
                  onSuccess: () => {
                    toast.ok('Отбелязано като прегледано');
                    close();
                  },
                  onError: (error) => toast.error('Не стана', error instanceof Error ? error.message : undefined),
                },
              )
            }
          >
            Прегледано
          </Button>
        </>
      }
    >
      <Field label="Бележка (по желание)" hint="Например: обяснено от шофьора, грешка в картата, платено на ръка.">
        <Input value={note} onChange={(e) => setNote(e.target.value)} data-autofocus />
      </Field>
    </Dialog>
  );
}
